var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_953_22550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 10.3312H11.149C11.3277 9.58095 11.5597 8.89112 11.835 8.28125C11.3089 8.57372 10.8203 8.941 10.3829 9.37834C10.0874 9.67392 9.82393 9.99308 9.59375 10.3312Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 17.6641C9.82398 18.0022 10.0874 18.3214 10.3829 18.6169C10.8203 19.0543 11.3089 19.4216 11.835 19.714C11.5596 19.1041 11.3277 18.4143 11.149 17.6641H9.59375Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4092 10.3312C18.179 9.99308 17.9156 9.67392 17.62 9.37834C17.1827 8.941 16.6941 8.57372 16.168 8.28125C16.4434 8.89112 16.6752 9.58095 16.854 10.3312H18.4092Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2288 8.86219C14.7024 7.80934 14.1742 7.46875 14.0009 7.46875C13.8276 7.46875 13.2995 7.80934 12.7731 8.86219C12.5551 9.29832 12.3679 9.7951 12.2148 10.3347H15.787C15.6339 9.7951 15.4468 9.29827 15.2288 8.86219Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7731 19.1366C13.2995 20.1894 13.8276 20.53 14.0009 20.53C14.1742 20.53 14.7024 20.1894 15.2288 19.1366C15.4468 18.7004 15.634 18.2037 15.787 17.6641H12.2148C12.368 18.2037 12.5551 18.7005 12.7731 19.1366Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7349 14.0022C10.7349 13.4319 10.7631 12.8749 10.8165 12.3359H8.68252C8.54181 12.8732 8.46875 13.432 8.46875 14.0022C8.46875 14.5724 8.54176 15.1312 8.68252 15.6685H10.8165C10.7631 15.1295 10.7349 14.5725 10.7349 14.0022Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2652 14.0022C17.2652 14.5725 17.237 15.1295 17.1836 15.6685H19.3176C19.4583 15.1312 19.5313 14.5724 19.5313 14.0022C19.5313 13.432 19.4583 12.8732 19.3176 12.3359H17.1836C17.237 12.8749 17.2652 13.4319 17.2652 14.0022Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0ZM14 22.5312C9.28834 22.5312 5.46875 18.7117 5.46875 14C5.46875 9.28834 9.28834 5.46875 14 5.46875C18.7117 5.46875 22.5312 9.28834 22.5312 14C22.5312 18.7117 18.7117 22.5312 14 22.5312Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 12.3359C11.7666 12.8774 11.7344 13.4366 11.7344 14.0022C11.7344 14.5678 11.7666 15.127 11.8281 15.6685H16.1729C16.2344 15.127 16.2666 14.5678 16.2666 14.0022C16.2666 13.4366 16.2344 12.8774 16.1729 12.3359H11.8281Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.168 19.714C16.6941 19.4216 17.1827 19.0543 17.62 18.6169C17.9156 18.3214 18.179 18.0022 18.4092 17.6641H16.854C16.6752 18.4143 16.4434 19.1041 16.168 19.714Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 7.5,
    stroke: "#20C3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_953_22550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/websiteIcon.c053b634feaeb027f77aa5d5395c8d26.svg";
export { ForwardRef as ReactComponent };